const mutations = {

  CHANGE_NAV_INDEX(state, _index) {
    state.navIndex = _index
    sessionStorage.navIndex = _index
  },
  CHANGE_NAV_MODULE(state, _module) {
    state.navModule = _module
    sessionStorage.navModule = _module
  },
  CHANGE_USER_ROLE(state, _user) {
    state.userRole = Number(_user)
  },
  // 设置当前企业微信上下文
  wwContext(state, _wwContext) {
    state.wwContext = _wwContext
  },
  // 设置当前微信外部联系人用户id
  wwContactUserId(state, _contactId) {
    state.wwContext.contactUserId = _contactId
  },
  // 设置当前企业微信联系人信息
  wwContactType(state, _type) {
    state.wwContext.contactType = _type
  },
  // 设置当前微信外部联系人所属corpid
  wwContactCorpId(state, _contactCorpId) {
    state.wwContext.contactCorpId = _contactCorpId
  },
  // 设置进入app的入口场景
  wwAppEntry(state, _appEntry) {
    state.wwContext.appEntry = _appEntry
  },
  // 设置群聊id
  wwGroupChatId(state, _chatId) {
    state.wwContext.groupChatId = _chatId
  },
  // 设置当前企业微信联系人信息
  wwContact(state, _contact) {
    state.wwContact = _contact
  },
  // 设置当前企业微信联系人信息
  cppContact(state, _contact) {
    state.cppContact = _contact
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js